import { apiConnector } from "../apiconnector";
import { hazopEndpoints } from "../apis";
import toast from "react-hot-toast";

const { GENERATE_AI_HAZOP_API } = hazopEndpoints;

export const generateAIHazop = async (drawingId, settings, processData) => {
  const toastId = toast.loading("Generating AI HAZOP analysis...");
  
  try {
    
    const response = await apiConnector(
      "POST",
      GENERATE_AI_HAZOP_API,
      {
        drawingId,
        settings,
        processData
      },
    );
    if (response?.success) {
      toast.success("AI HAZOP generated successfully!");
      return response;
    } else {
      throw new Error(response?.data?.message || "Failed to generate AI HAZOP");
    }
  } catch (error) {
    console.error("GENERATE_AI_HAZOP_API ERROR:", error);
    toast.error(error?.response?.data?.message || "Failed to generate AI HAZOP");
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to generate AI HAZOP"
    };
  } finally {
    toast.dismiss(toastId);
  }
};